import { Component } from "react";
import { Box, Button, CircularProgress, Drawer, IconButton, Stack, Typography } from "@mui/material";
import { MdOutlineClose, MdPlayArrow, MdStop } from "react-icons/md";
import BasicDataGrid from "../ui/BasicDataGrid";
import Inventario from "./Inventario";
import { httpGet, httpPost } from "../util/http";
import dayjs from 'dayjs';
import { INVENTARIO_ABERTO, INVENTARIO_CONCLUIDO, INVENTARIO_EM_CONTAGEM } from "../util/contants";
import InventStatus from "../ui/InventStatus";
import ReservDialog from "../ui/ReservDialog";
import ErrorDialog from "../ui/ErrorDialog";
import CloseInventDialog from "../ui/CloseInventDialog";
import MessageDialog from "../ui/MessageDialog";
import Cookies from "universal-cookie";

export default class DepositoFicha extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            btnLoading: false,
            showDepFicha: false,
            showUnidFicha: false,
            showInventDialog: false,
            showOpenDialog: false,
            semanalAberto: false,
            reservados: [],
            showReservDialog: false,
            showCloseInventDialog: false,
            showWarningDialog: false,
            err: 'Erro idiota & besta somente para teste.',
            step: 0,
        };

        this.columns = [
            { field: 'data', headerName: 'Data/Horário', flex: 1, valueGetter: (params) => dayjs(params.row?.created_at).format('DD/MM/YYYY - HH:mm') },
            {
                field: 'status', headerName: 'Status', flex: 1, valueGetter: (params) => this.checkStatus(params?.row)
            },
            { field: 'contagens', headerName: 'Nº de contagens', width: 130, valueGetter: (params) => params.row?.contagens?.length },
        ];

        this.cookies = new Cookies();
        this.user = this.cookies.get('user');
    }

    checkStatus(inventario) {
        if (inventario.encerramento) {
            return 'Concluído';
        }
        if (this.state.deposito?.status == INVENTARIO_CONCLUIDO) {
            return 'Concluído';
        }
        if (this.state.deposito?.status == INVENTARIO_EM_CONTAGEM) {
            return 'Em contagem';
        }
        return 'Aberto';
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        this.setState({ loading: true });
        httpGet('/depositos/' + this.props.deposito?.id + '/read',
            deposito => {
                console.log(deposito)
                this.setState({
                    deposito,
                    loading: false,
                    semanalAberto: deposito.semanalAberto,
                });
            },
            error => {
                console.log(error);
                this.setState({ loading: false });
            },
        );
    }

    inventstatus(start) {
        this.setState({ btnLoading: true });
        httpPost('/inventarios/' + this.props.deposito?.id + (start ? '/start' : '/stop'),
            {},

            (data, message) => {
                if (message === 'RESERV') {
                    //console.log(data);
                    this.setState({
                        showReservDialog: true,
                        reservados: data,
                    });
                } else {
                    if ((start === false) && (data.step !== INVENTARIO_CONCLUIDO)) {
                        this.setState({ step: data.step });
                        setTimeout(() => this.inventstatus(false), 100);
                        return;
                    } else {
                        this.setState({ showCloseInventDialog: false });
                        this.refresh();
                        if (this.props.onRefresh) {
                            this.props.onRefresh();
                        }
                    }
                }
                this.setState({ btnLoading: false });
            },

            error => {
                this.setState({
                    btnLoading: false,
                    showErrDialog: true,
                    showCloseInventDialog: false,
                    err: error.message,
                    step: 0,
                });
                //console.error(error);
            },

            false
        );
    }

    fecharInventario() {
        this.setState({ step: INVENTARIO_ABERTO });
        this.inventstatus(false);
    }

    abrirInventario() {
        this.setState({ showOpenDialog: false });
        if (this.state.semanalAberto) {
            this.setState({ showWarningDialog: true });
            return;
        }
        this.inventstatus(true);
    }

    render() {
        return (
            <Drawer open={true} anchor="right">
                <Box height={40}></Box>
                {this.state.showErrDialog && <ErrorDialog onClose={() => this.setState({ showErrDialog: false })} msg={this.state.err} />}
                {this.state.showReservDialog && <ReservDialog produtos={this.state.reservados} onClose={() => this.setState({ showReservDialog: false })} />}
                {this.state.showOpenDialog && <MessageDialog title="ATENÇÃO TOTAL" onConfirm={() => this.abrirInventario()} onClose={() => this.setState({ showOpenDialog: false })} >Tem certeza que deseja iniciar um novo inventário para este depósito?</MessageDialog>}
                {this.state.showWarningDialog && <MessageDialog title="NÃO É POSSÍVEL CONTINUAR" onClose={() => this.setState({ showWarningDialog: false })} >Não é possível iniciar um inventário. Existe uma contagem semanal aberta para este depósito.</MessageDialog>}
                {this.state.showCloseInventDialog && <CloseInventDialog onConfirm={() => this.fecharInventario()} step={this.state.step} onClose={() => this.setState({ showCloseInventDialog: false })} />}
                {this.state.showInventDialog && <Inventario onRefresh={() => this.refresh()} inventario={this.state.currInvent} deposito={this.state.deposito} onClose={e => this.setState({ showInventDialog: false })} />}
                <Stack width={600} p={2} gap={1} flex={1}>
                    <Stack>
                        <Stack direction="row">
                            <Typography color="primary" variant="h6"><b>Ficha do depósito</b></Typography>
                            <Box flex={1} />
                            <IconButton onClick={e => this.props.onClose(e)} title="Fechar" color="primary"><MdOutlineClose /></IconButton>
                        </Stack>
                        <Stack direction="row" gap={1}>
                            <Typography variant="caption"><b>{this.props.deposito?.nome + ' - '}</b></Typography>
                            <Typography variant="caption"><b>{this.props.deposito?.unidade.nome}</b></Typography>
                            {/* <Box  flex={1} borderTop={1} borderColor="primary.main" height={0} mt={0.9} /> */}
                        </Stack>
                    </Stack>


                    <Stack direction="row" gap={1}>
                        {this.state.deposito?.status != INVENTARIO_CONCLUIDO ?
                            <Button onClick={e => this.setState({ showCloseInventDialog: true })} size="small" startIcon={this.state.btnLoading ? <CircularProgress sx={{ color: 'rgba(0, 0, 0, 0.26)' }} size={20} /> : <MdStop />} color="error" variant="contained" disableElevation disabled={this.state.loading || this.state.btnLoading || (this.state.deposito?.status == INVENTARIO_EM_CONTAGEM) || (this.user.isAnalista)}>Encerrar inventário</Button> :
                            <Button onClick={e => this.setState({ showOpenDialog: true })} size="small" startIcon={this.state.btnLoading ? <CircularProgress sx={{ color: 'rgba(0, 0, 0, 0.26)' }} size={20} /> : <MdPlayArrow />} color="success" variant="contained" disableElevation disabled={this.state.loading || this.state.btnLoading}>Iniciar inventário</Button>
                        }
                    </Stack>
                    {this.state.deposito?.status != INVENTARIO_CONCLUIDO &&
                        <InventStatus deposito={this.props.deposito} />
                    }
                    {/* <Accordion elevation={0} disableGutters defaultExpanded>
                        <AccordionSummary expandIcon={<MdExpandMore />} sx={{ bgcolor: '#f0fbff' }}><Typography variant="caption" color="primary">Último inventário</Typography></AccordionSummary>
                        <AccordionDetails sx={{ bgcolor: '#fafafa' }}>
                            teste
                        </AccordionDetails>
                    </Accordion> */}
                    <Stack maxHeight="calc(100vh - 280px)" flex={1}>
                        <BasicDataGrid
                            props={{
                                onRowClick: e => this.setState({ showInventDialog: true, currInvent: e.row }),
                                loading: this.state.loading
                            }} rows={this.state.deposito?.inventarios ? this.state.deposito?.inventarios : []} columns={this.columns} />
                    </Stack>
                </Stack>
            </Drawer>
        );
    }
}
